import React, { Component } from 'react';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga';
import { HashRouter } from 'react-router-dom';
import detectBrowserLanguage from 'detect-browser-language';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSpinner,
  faBars,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import ja from 'react-intl/locale-data/ja';
import 'react-toastify/dist/ReactToastify.css';
import store from '../services/store';
import { setLang } from '../services/Application/actions';
import Router from '../routes';
import config from '../config';
import './App.scss';

class App extends Component {
  constructor(props) {
    super(props);
    // Setup local state
    this.state = {
      initialized: false,
    };

    // Setup redux store
    this.store = store();

    ReactGA.initialize(config.GOOGLE_ANALYTICS, {
      // debug: process.env.NODE_ENV !== 'production',
    });

    // eslint-disable-next-line no-undef
    ReactGA.pageview(window.location.pathname + window.location.search);

    // Setup internationalization
    addLocaleData([
      ...en,
      ...ja,
    ]);

    // Add icons
    library.add(faSpinner);
    library.add(faBars);
    library.add(faTimes);
  }

  componentWillMount() {
    // Set default lanuage
    this.store.dispatch(setLang(detectBrowserLanguage().slice(0, 2)));
  }

  componentDidMount() {
    this.setState({ initialized: true });
  }

  render() {
    const { initialized } = this.state;

    return (
      <Provider store={this.store}>
        {initialized ? (
          <HashRouter>
            <Router />
          </HashRouter>
        ) : null}
      </Provider>
    );
  }
}

export default App;
